module.exports = __webpack_public_path__ + "static/img/tst2-02.d888dbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-02.jpg
// module id = 6eHl
// module chunks = 1